// components/ProtectedRoute.jsx
import { Navigate, Outlet, useLocation } from "react-router-dom";

const ProtectedRoute = ({ redirectPath = "/login" }) => {
  const location = useLocation();
  const isAuthenticated = localStorage.getItem("token");
  if (!isAuthenticated) {
    return <Navigate to={redirectPath} replace />;
  }
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const isStaff = String(user.userType || user.UserType || "").toLowerCase() === "staff";
  const forceChangePassword = Boolean(user.forceChangePassword || user.ForceChangePassword);
  if (isStaff && forceChangePassword && location.pathname !== "/staff/change-password") {
    return <Navigate to="/staff/change-password" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
